export default __webpack_public_path__ + "static/media/Calendar.9fd088c8.svg";